module.exports = __webpack_public_path__ + "img/logo_birdlife_africa.a353c7d7.jpg";